'use strict';

import Swal from 'sweetalert2';
import { modalSaveReport } from '../../modules/modalSaveReport.js';

export const activities = () => {
  modalSaveReport(validateFields);

  function validateFields() {
    let isValid = true;
    const $textArea = document.querySelector('textarea[required]');
    const textAreaValue = $textArea ? $textArea.value.trim() : '';

    if (!textAreaValue) {
      Swal.fire({
        icon: 'error',
        title: 'Atenção!',
        text: 'Preencha os campos corretamente',
      });

      isValid = false;
    }

    return isValid;
  }
};
